module.exports = __webpack_public_path__ + "media/sfx_click_edit.377e75e6.mp3";